/** Shows a speaker icon that plays TTS when clicked */
import * as preact from "preact";

import * as deviceDetect from "deviceDetect";
import * as practiceUtils from "practiceUtils";
import * as textToSpeech from "textToSpeech";

interface Props {
  text: string;
  language: string;
  forceBrowserTTS?: boolean;
}

interface State {}

export default class PlayTTSView extends preact.Component<Props, State> {
  constructor(props: Props) {
    super(props);
  }

  render() {
    if (!textToSpeech.languageSupported(this.props.language)) {
      return null;
    }

    return (
      <a
        class="playTTSButton"
        href="#"
        onClick={(event) => {
          event.preventDefault();
          event.stopPropagation();
          practiceUtils.playTTS(
            this.props.language,
            this.props.text,
            this.props.forceBrowserTTS
          );
        }}
      >
        <i class="icon-volume-up"></i>
      </a>
    );
  }

  componentDidMount() {
    if (!textToSpeech.languageSupported(this.props.language)) {
      return;
    }

    // Set up keyboard handler which plays TTS when Ctrl+P is pressed
    document.addEventListener("keydown", this.keydownHandler);
  }

  keydownHandler = (event: KeyboardEvent) => {
    if (
      (deviceDetect.info().mac && event.metaKey && event.key === "p") ||
      (!deviceDetect.info().mac && event.ctrlKey && event.key === "p")
    ) {
      event.preventDefault();
      event.stopPropagation();
      practiceUtils.playTTS(this.props.language, this.props.text);
    }
  };

  componentWillUnmount(): void {
    if (!textToSpeech.languageSupported(this.props.language)) {
      return;
    }

    // Remove keyboard handler
    document.removeEventListener("keydown", this.keydownHandler);
  }
}
